<template>
  <Col 
    :center="$mq == 'phone'" 
    :centered="$mq != 'phone'" 
    :class="{pt8: $mq == 'phone'}" 
    full 
    class="c-login"
  >
    <img
      v-if="vendor"
      :src="require(`@/assets/images/${vendorVars.logoName}.svg`)"
      height="30"
      class="mb4"
      alt=""
    />
    <!-- Обычная форма входа -->
    <LoginFormEnter v-if="enterMode" :show-ua.sync="showUA" :show-pa.sync="showPA" @error="showAlert" />
    
    <!-- Форма восстановления пароля -->
    <LoginRestoreForm v-else-if="restoreMode" @error="showAlert" />

    <!-- Форма сброса пароля -->
    <LoginResetForm v-else-if="resetMode" @error="showAlert" />

    <!-- footer -->
    <LoginFooter :user-agreement.sync="showUA" :personal-agreement.sync="showPA" />

    <Alert ref="loginErrorAlert" type="error" />
  </Col>
</template>

<script>
import load_vendor from "@/mixins/load_vendor";

// import AppLoginGoogle from "@/components/Login/LoginBarGoogle.vue";
// import AppLoginMicrosoft from "@/components/Login/LoginBarMicrosoft.vue";

export default {
  name: 'LoginPage',

  components: {
    Alert: () => import('@/components/common/Alert'),
    LoginFormEnter: () => import('./components/LoginFormEnter.vue'),
    LoginRestoreForm: () => import('./components/LoginRestoreForm.vue'),
    LoginResetForm: () => import('./components/LoginResetForm.vue'),
    LoginFooter: () => import('./components/LoginFooter.vue'),
  },

  mixins: [load_vendor],
  
  data() {
    return {      
      showUA: false,
      showPA: false,
    };
  },

  computed: {
    enterMode() {
      return this.$route.name === "Login";
    },
    resetMode() {
      return this.$route.name === "ResetPassword";
    },
    restoreMode() {
      return this.$route.name === "ForgotPassword";
    },
  },

  watch: {
    errorLogin(val) {
      if (!val) return;
    },
  },
  
  async created() {
    const result = await this.axios.get('/api/env')
      if (!result) {
        this.noConnection = true
        console.log('Error of connection!')
        return 
      }
    const vendor = result.data.vendor
    document.title = vendor == 'yandex' ? 'Connectable' : 'Intranetable'
  },

  methods: {
    showAlert({header, message}) {
      this.$refs.loginErrorAlert.show(header, message)
    }
  }

};
</script>

<style lang="scss">
.user-agreement {
  .dot-link {
    color: royalblue;
    text-decoration: underline dotted;
    cursor: pointer;
  }
}
/**
 * ----------------------------------------
 * animation scale-out-vertical
 * ----------------------------------------
 */
@keyframes scale-out-vertical {
  0% {
    transform: scaleY(1);
    opacity: 1;
  }
  100% {
    transform: scaleY(0);
    opacity: 0;
  }
}
@keyframes scale-in-vertical {
  0% {
    transform: scaleY(0);
    opacity: 0;
  }
  100% {
    transform: scaleY(1);
    opacity: 1;
  }
}

.scale-in-vertical {
  animation: scale-in-vertical 0.3s cubic-bezier(0.165, 0.84, 0.44, 1) both;
}
.scale-out-vertical {
  animation: scale-out-vertical 0.3s cubic-bezier(0.165, 0.84, 0.44, 1) both;
}
</style>

<style lang="stylus" scoped>
.c-login
  background-color #001533
  .page-block
    border-radius 12px
    width 362px
    min-height 350px

.title
  font-size 2em
  text-align center
.invalid-feedback
  color salmon
</style>
